import { DropdownMenu, DropdownMenuTrigger } from '@/components/ui/dropdown-menu';

export const Menu = DropdownMenu;

export const MenuTrigger = DropdownMenuTrigger;
